import React from 'react';
import { useTranslate } from 'react-admin';
import FloatNumberInput from '../../../../base/components/customized/FloatNumberInput';
import { INVOICE_SERVICE } from '../../../../constant/invoice';
import { useHasCreateInvoicePermission, useHasReadInvoicePermission } from '../../../group/components/utils';

const DefaultRoyaltyRateInput = () => {
  const t = useTranslate();
  const hasReadInvoicePermission = useHasReadInvoicePermission();
  const hasCreateInvoicePermission = useHasCreateInvoicePermission();

  const monthlyRoyaltyValidate = (value) => {
    if (value < 0 || value === 0) {
      return t('ra.validation.greater', {
        min: 0,
      });
    }

    if (value > 100) {
      return t('ra.validation.maxValue', {
        max: 100,
      });
    }

    return undefined;
  };

  const mktRoyaltyValidate = (value) => {
    if (value < 0 || value === 0) {
      return t('ra.validation.greater', {
        min: 0,
      });
    }

    if (value > 100) {
      return t('ra.validation.maxValue', {
        max: 100,
      });
    }

    return undefined;
  };

  if (!hasReadInvoicePermission) return null;

  return (
    <>
      <FloatNumberInput
        source="monthlyRoyalty"
        suffix="%"
        validate={monthlyRoyaltyValidate}
        label={`common.invoiceServiceRoyalty.${INVOICE_SERVICE.MONTHLY_GGR}`}
        disabled={!hasCreateInvoicePermission}
      />
      <FloatNumberInput
        source="mktRoyalty"
        suffix="%"
        validate={mktRoyaltyValidate}
        label={`common.invoiceServiceRoyalty.${INVOICE_SERVICE.MKT_FREE_SPIN}`}
        disabled={!hasCreateInvoicePermission}
      />
    </>
  );
};

export default DefaultRoyaltyRateInput;
